import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { User, Zap, BarChart3, FileText, Share2, ArrowRight } from 'lucide-react';
export function Slide2() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.4
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <div className="slide-content" data-id="element-38">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="flex justify-between items-end mb-12" data-id="element-39">
        <h1 className="slide-headline mb-0" data-id="element-40">
          From content <span className="text-roche-red" data-id="element-41">→</span> to
          conversations
        </h1>

        {/* Decorative Visual: PDF to Nodes */}
        <div className="hidden lg:flex items-center space-x-6 text-text-muted opacity-60" data-id="element-42">
          <FileText className="w-8 h-8" data-id="element-43" />
          <motion.div initial={{
          width: 0,
          opacity: 0
        }} animate={{
          width: 40,
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1
        }} className="h-px bg-current" data-id="element-44" />
          <ArrowRight className="w-5 h-5" data-id="element-45" />
          <motion.div initial={{
          width: 0,
          opacity: 0
        }} animate={{
          width: 40,
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1.2
        }} className="h-px bg-current" data-id="element-46" />
          <Share2 className="w-8 h-8 text-roche-red" data-id="element-47" />
        </div>
      </motion.div>

      <motion.div className="flex-1 grid grid-cols-3 gap-8 mt-8" variants={containerVariants} initial="hidden" animate="visible" data-id="element-48">
        {/* Card 1 */}
        <motion.div variants={cardVariants} className="bg-card-bg rounded-2xl p-10 border border-gray-100 flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-49">
          <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-8 shadow-sm text-roche-red" data-id="element-50">
            <User className="w-8 h-8" data-id="element-51" />
          </div>
          <h3 className="text-2xl font-bold mb-4" data-id="element-52">Customer-driven</h3>
          <p className="text-xl text-text-muted leading-relaxed" data-id="element-53">
            HCP chooses what matters
          </p>
        </motion.div>

        {/* Card 2 */}
        <motion.div variants={cardVariants} className="bg-card-bg rounded-2xl p-10 border border-gray-100 flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-54">
          <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-8 shadow-sm text-roche-red" data-id="element-55">
            <Zap className="w-8 h-8" data-id="element-56" />
          </div>
          <h3 className="text-2xl font-bold mb-4" data-id="element-57">Short & rewarding</h3>
          <p className="text-xl text-text-muted leading-relaxed" data-id="element-58">
            Low effort <span className="text-roche-red mx-1" data-id="element-59">→</span> instant
            insight
          </p>
        </motion.div>

        {/* Card 3 */}
        <motion.div variants={cardVariants} className="bg-card-bg rounded-2xl p-10 border border-gray-100 flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-60">
          <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-8 shadow-sm text-roche-red" data-id="element-61">
            <BarChart3 className="w-8 h-8" data-id="element-62" />
          </div>
          <h3 className="text-2xl font-bold mb-4" data-id="element-63">Data-rich</h3>
          <p className="text-xl text-text-muted leading-relaxed" data-id="element-64">
            Every click = behavioral signal
          </p>
        </motion.div>
      </motion.div>

      <motion.div className="slide-punchline" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 1.2
    }} data-id="element-65">
        Not content consumption — active engagement
      </motion.div>
    </div>;
}